import { request } from "../request";
export const createOrganization = (params) =>
  request(`/v1/organization/create`, "post", {
    json: params,
  });
export const getOrgPicSts = (params) =>
  request(`/v1/cos/getOrgPicSts`, "get", { params });

// 获取入驻权益
export const getEquity = (params) =>
  request(`/v1/organization/settledRights/get`, "get");
